module.exports = __webpack_public_path__ + "static/media/itunes.2ccd1e6e.png";